'use client'
import { Organization } from 'types'
import { useEffect } from 'react'

export const GA_TRACKING_ID = 'GTM-WN8TNCDN'

// https://ryanelainska.com/blog/google-tag-manager-in-react

// google tag manager implementaion as per example:
// https://hoangtrinhj.com/using-google-analytics-with-next-js
// updated for typescript

declare global {
  interface Window {
    gtag: any
  }
}

interface GtagProps {
  org?: Organization
}
export function Gtag({ org }: GtagProps): React.ReactNode {
  useEffect(() => {
    if (org && window?.gtag) {
      window?.gtag('send', 'pageview', {
        dimension0: org.id
      })
    }
  }, [])

  return null
}

export const sendSearchToGA = (term: string): void => {
  if (window?.gtag) {
    window?.gtag('event', 'search', {
      search_term: term
    })
  }
}
